import { v4 as uuidv4 } from "uuid";

const getRandomUUID = (): string => {
  const randomUUID = uuidv4() as string;
  return randomUUID;
};

export default { getRandomUUID };
